import { MasterEvent, Market } from "..";
import { observable, action, computed } from "mobx";

export enum ItemState {
    loading = 0,
    available = 1,
    unavailable = 2
}

export class PickedEvent {
    MasterEventID: number;

    EventID: number;

    IsQA: boolean;

    IsOutright: boolean;

    LineTypeID: number;

    HasLivestream: boolean;

    Link: string;
    Mode: string;
    navHandler: Application;
    @observable event?: MasterEvent;

    @observable market?: Market;
    @observable state: ItemState;

    constructor(source: any) {
        this.MasterEventID = source.MasterEventID;
        this.HasLivestream = !!source.HasLivestream;
        this.EventID = source.EventID;
        this.IsOutright = source.IsOutright;
        this.IsQA = source.IsQA;
        this.LineTypeID = source.LineTypeID;
        this.state = ItemState.loading;
        this.navHandler = window["Application"];
        this.Link = source.Link;

        this.Mode = source.Mode ? source.Mode : undefined;
        this.event = source.event ? new MasterEvent(source.event) : undefined;
        this.market = source.market ? new Market(source.market) : undefined;
    }

    @action.bound
    upsertEvent(masterEvent: MasterEvent): void {
        this.event
            ? this.event.update(masterEvent)
            : (this.event = masterEvent);
    }

    upsertMarket(market: Market): void {
        if (this.event) {
            this.event.upsertMarket(market);
        }
    }

    removeMarkets(marketIds: string[]): void {
        if (this.event) {
            this.event.removeMarkets(marketIds);
        }
    }

    @action.bound
    deleteEvent(): void {
        this.event = undefined;
    }

    @action.bound
    updateMarket(market?: Market): void {
        this.market = market;
    }

    /* istanbul ignore next */
    @action.bound setState(state: ItemState): void {
        this.state = state;
    }

    @computed get getLink() {
        return this.event
        && this.event.isLive
        && this.navHandler
        && this.navHandler.Navigation
        ? this.navHandler.Navigation.getLiveEventLink(this.event.id)
        : this.Link;
    }
}